import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { vuetify } from './plugins'
import VueApollo from 'vue-apollo'
import apolloClient from '@/services/gql/client.js'
import { i18n } from '@/plugins/vue-i18n'

import './global-mixins'

require('@/assets/css/main.css')

Vue.config.productionTip = false

const apolloProvider = new VueApollo({ defaultClient: apolloClient })

new Vue({
  router,
  store,
  apolloProvider,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
